<template>
  <div class="pcg-nopermission d-flex text-center">
    <div class="mx-auto mt-5">
      <div class="mb-4">
        <img src="./img/unown.gif" alt="unown" height="140">
      </div>
      {{ translation.general.userIdNotShared }}
    </div>
  </div>
</template>

<script>
import {translation} from "@/utils/translations";

export default {
  name: "NotWhitelisted",
  setup() {
    return {
      translation
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/variables';

.pcg-nopermission {
  background-color: $poketwitch-branding-color;
  color: white;
  font-family: "Josefin Sans", sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
</style>